import { Row, Col, Button } from "antd";
import React, { Component } from "react";
import PlantOrder from "../../components/DashboardStatsCard/plantorder";
import { connect } from "react-redux";
import { DashboardAction, UserAction } from "../../store/actions";
import moment from "moment";
import CustomModal from "../../components/modals/customModal";
import DeleteOrder from "../../assets/images/delete_order.png";
import { BsCalendarMinus, BsExclamationLg } from "react-icons/all";
import { formatToNumber, numberWithCommas } from "../../../plant_dir/config/utils";

class CompaniesDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: {
        order: "asc",
        page: 1,
        per_page: 10,
        column: "name",
        status: "pending",
      },
      isClose: false,
      isOpenModal: false,
      isOpenLogisticModal: false,
      userId: "",
      isAllow: "",
    };
  }
  componentDidMount() {
    const { getOrders } = this.props;

    const companyId = this.props.location?.state?.id;

    if (companyId) {
      getOrders(this.state.filter, companyId);
    }
  }
  componentDidUpdate(preProps, preState) {
    const { getOrders } = this.props;

    if (preProps.metaData !== this.props.metaData) {
      this.setState({
        filter: {
          ...this.state.filter,
          page: this.props?.metaData?.current_page,
          totalCount: this.props?.metaData?.total_records,
          currentCount: this.props?.metaData?.current_records,
          total_pages: this.props?.metaData?.total_pages,
        },
      });
    }

    if (
      preState.filter.page !== this.state.filter.page ||
      preState.filter.search !== this.state.filter.search
    ) {
      getOrders(this.state.filter, this.props.location.state.id);
    }
  }
  toggleModal = () => {
    this.setState({
      isOpenModal: false,
      isOpenLogisticModal: false,
    });
  };

  currentPage = (e) => {
    // this.setState({
    //   filter: {
    //     ...this.state.filter,
    //     page: this.state.filter?.page + 1,
    //   },
    // });
  };

  onChangeTab = (key) => {
    const {
      getOrders,
      location: { state },
    } = this.props;

    if (key == "1") {
      this.setState({
        filter: {
          ...this.state.filter,
          status: "",
        },
      });

      getOrders({ ...this.state.filter, status: "" }, state.id);
    }
    if (key == "2") {
      this.setState({
        filter: {
          ...this.state.filter,
          status: "approved",
        },
      });
      getOrders(
        {
          ...this.state.filter,
          status: "approved",
        },
        state.id
      );
    }
    if (key == "3") {
      this.setState({
        filter: {
          ...this.state.filter,
          status: "dispatched",
        },
      });
      getOrders(
        {
          ...this.state.filter,
          status: "dispatched",
        },
        state.id
      );
    }
    if (key == "4") {
      this.setState({
        filter: {
          ...this.state.filter,
          status: "rejected",
        },
      });
      getOrders(
        {
          ...this.state.filter,
          status: "rejected",
        },
        state.id
      );
    }
    if (key == "5") {
      this.setState({
        filter: {
          ...this.state.filter,
          status: "completed",
        },
      });
      getOrders(
        {
          ...this.state.filter,
          status: "completed",
        },
        state.id
      );
    }
  };
  currentPage = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        page: this.state.filter?.page + 1,
      },
    });
  };

  previousPage = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        page: this.state.filter?.page - 1,
      },
    });
  };
  onChangeText = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        search: e.target.value,
      },
    });
  };

  onChangeFilter = (end_date, start_date) => {
    // this.setState({
    //   filter: {
    //     ...this.state.filter,
    //     start_date,
    //     end_date,
    //   },
    // });
  };
  onChangePeriod = (period) => {
    this.setState({
      filter: {
        ...this.state.filter,
        period,
      },
    });
  };

  handleModal = () => {
    this.state.isOpenModal &&
      this.props.plantActivation(
        this.state.userId,
        () => {
          this.toggleModal();
        },
        "deactivate"
      );
  };
  render() {
    const { isOpenModal, isOpenLogisticModal } = this.state;
    // const { business_name } = this.props?.location?.state;

    const columns = [
      {
        title: "ORDER DETAILS",
        dataIndex: "",
        align: "left",
        sortDirections: ["descend", "ascend"],
        key: "rmx_product",
        className: "action-class",
        width: "20%",
        sorter: (a, b) =>
          a.order_products[0]?.rmx_product?.name.localeCompare(
            b.order_products[0]?.rmx_product?.name
          ),
        render: (r) => {
          return (
            // <div>
            //   <h1 className="font-w-700 text-capitilize">{`Order# ${r?.order_number}`}</h1>
            //   <p>{r?.order_products[0]?.rmx_product?.name}</p>
            // </div>

            <div>
              <h1 className="font-w-700">{`Order# ${r?.order_number}`}</h1>
              {r.order_products.map((item, index) => {
                return (
                  <span key={index}>
                    {" "}
                    {(index ? "," : "") + item?.rmx_product?.name}
                  </span>
                );
              })}
            </div>
          );
        },
      },
      {
        title: "CONTRACTOR",
        dataIndex: "",
        align: "left",
        key: "first_name",
        className: "action-class",
        width: "20%",
        sorter: (a, b) =>
          a.contractor?.user?.first_name.localeCompare(
            b.contractor?.user?.first_name
          ),
        render: (r) => {
          return (
            <div>
              <h1 className="font-w-700">{`${r?.contractor?.user?.first_name} ${r?.contractor?.user?.last_name}`}</h1>
              <p>{formatToNumber(r?.contractor?.user?.phone || '')}</p>
            </div>
          );
        },
      },
      {
        title: "DATE",
        dataIndex: "",
        align: "left",
        className: "action-class",
        width: "20%",
        render: (r) => (
          <div class="chip chips-s">
            <span class="pm-circle am-pm-circle">
              {r?.preferred_delivery_period == "am" ? (
                <BsExclamationLg color="red" size={18} />
              ) : (
                <BsExclamationLg color="grey" size={18} />
              )}
            </span>
            <span style={{ marginRight: "5px" }}>
              <BsCalendarMinus size="12" />
            </span>
            <span>
              {moment(r?.preferred_delivery_datetime).format("MM-DD-YYYY")}
            </span>
          </div>
        ),
      },
      {
        title: "PRICE",
        dataIndex: "total_amount",
        align: "left",
        className: "action-class",
        width: "20%",
        render: (r) => <p>{`$ ${numberWithCommas(Number(r)?.toFixed(2))}`}</p>,
      },
      {
        title: "PO#",
        dataIndex: "",
        align: "left",
        width: "20%",
        className: "action-class",
        // sortDirections: ["descend", "ascend"],
        // sorter: (a, b) => a.order_number.localeCompare(b.order_number),
        key: "purchase_order_num",
        render: (r) => (
          // if(r.purchaseOrder)
          <p className="">
            {
              r?.purchase_order_num ? r?.purchase_order_num : "-"
            }
          </p>
        ),
      },
      {
        title: "ACTION",
        dataIndex: "",
        align: "left",
        className: "action-class",

        render: (r) => (
          <p
            className="st-primary pointer-cursor "
            onClick={() => {
              this.props.setPlantKeyTab("3");
              this.props.history.push({
                pathname: `/rmx/${r?.rmx_company_id}/orders/${r?.id}`,
              });
            }}
            style={{ fontSize: "12px" }}
          >
            DETAILS
          </p>
        ),
      },
    ];
    return (
      <Row justify="space-between">
        <Col span={24}>
          <PlantOrder
            {...this.props}
            inputText={`All Companies > ${this.props?.location?.state?.business_name}  Orders`}
            onChangeTab={this.onChangeTab}
            metaData={this.state.filter}
            currentPage={this.currentPage}
            previousPage={this.previousPage}
            onChangeText={this.onChangeText}
            onChangeFilter={this.onChangeFilter}
            onChangePeriod={this.onChangePeriod}
            columns={columns}
            isShowAsphaltPlants={true}
            onClearSearch={() =>
              this.setState({
                filter: { ...this.state.filter, search: "" },
              })
            }
            searchVal={this.state.filter.search}
            isShowPlusSign={true}
          />
        </Col>
        <CustomModal
          visible={isOpenModal || isOpenLogisticModal}
          onCancelModal={this.toggleModal}
          footer={[
            <Row justify="center">
              <Col
                className="d-flex justify-content-center"
                style={{ width: "100%" }}
              >
                <Button
                  style={{
                    backgroundColor: "#ff9800",
                    color: "#fff",
                    width: "30%",
                    border: "none",
                  }}
                  onClick={() => this.handleModal()}
                >
                  YES
                </Button>
                <Button
                  style={{
                    backgroundColor: "#26a69a ",
                    color: "#fff",
                    width: "30%",
                    border: "none",
                  }}
                  onClick={() => this.toggleModal()}
                >
                  NO
                </Button>
              </Col>
            </Row>,
          ]}
        >
          <Row justify="center">
            <Col className="d-flex justify-content-center">
              <img src={DeleteOrder} />
            </Col>
            <Col>
              <p>
                {this.state.isOpenLogisticModal == true
                  ? "Are you sure you want to deactivate this logistic partner?"
                  : "Are you sure you want to deactivate this plant company?"}
              </p>
            </Col>
          </Row>
        </CustomModal>
      </Row>
    );
  }
}
function mapStateToProps(store) {
  return {
    Orders: store.DashboardReducer.orders,
    manufacturePlants: store.DashboardReducer.manufacturePlant,
    user: store.AuthReducer.user,
    metaData: store.DashboardReducer.metaData,
    loading: store.DashboardReducer.isLodadingCount,
    isLoader: store.DashboardReducer.isOrder,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    getOrders: (params, id) =>
      dispatch(DashboardAction.getOrderReq(params, id)),
    plantActivation: (id, cb, params) =>
      dispatch(DashboardAction.plantActivationReq(id, cb, params)),
    getUserDetails: (id) => dispatch(UserAction.getUserDetailReq(id)),
    setPlantKeyTab: (e) =>
      dispatch(DashboardAction.getPlantTabProductKeyReq(e)),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(CompaniesDetails);
